/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ start: NonNullable<unknown>, end: NonNullable<unknown> }} Timeline_Event_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Timeline event from {start} to {end}" |
*
* @param {Timeline_Event_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_event_aria_label = /** @type {((inputs: Timeline_Event_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Event_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Evenement de la chronologie de ${i?.start} a ${i?.end}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Zeitachsenereignis von ${i?.start} bis ${i?.end}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Evento della cronologia da ${i?.start} a ${i?.end}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Хронология событий от ${i?.start} до ${i?.end}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Evento de la línea de tiempo de ${i?.start} a ${i?.end}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`从${i?.start}到${i?.end}的时间线事件`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.start} から ${i?.end} までのタイムラインイベント`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.start} से ${i?.end} तक की समयरेखा घटना`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Evento da linha do tempo de ${i?.start} a ${i?.end}`)
	return /** @type {LocalizedString} */ (`Timeline event from ${i?.start} to ${i?.end}`)
});